import {
  useBmsDashboard,
  useTempDashboard,
  usePumpDashboard,
  useEmsDashboard,
  useDgDashboard,
  useFmsDashboard,
  useHVCDashboard,
  useBoilerDashboard,
  useVIBDashboard,
  useWmsDashboard,
  // nbs_dashboard,
  useNBSDashboard,
  useTransDashboard,
  useAGRDashboard,
  support_dashboard,
  useAdminDashboard,
  useSuperAdminDashboard,
  useGASDashboard,
  useSTEAMDashboard,
  useIndoorDashboard,
  useOutdoorDashboard,
  useAIRDashboard, 
  useFLMSDashboard,
  useSolarDashboard
} from "./ems_dashboard";

// Custom hook to generate menu items
export const useMenuItems = () => {

  const superDashboard = useSuperAdminDashboard();
  const adminDashboard = useAdminDashboard();
  const emsDashboard = useEmsDashboard();
  const wmsDashboard = useWmsDashboard();
  const tempDashboard = useTempDashboard();
  const pumpDashboard = usePumpDashboard();
  const hvcDashboard = useHVCDashboard();
  const boilerDashboard = useBoilerDashboard();
  const indoorDashboard = useIndoorDashboard();
  const outdoorDashboard = useOutdoorDashboard();
  const dgDashboard = useDgDashboard();
  const vibDashboard = useVIBDashboard();
  const nbsDashboard = useNBSDashboard();
  const transDashboard = useTransDashboard();
  const agrDashboard = useAGRDashboard();
  const gasDashboard = useGASDashboard();
  const steamDashboard = useSTEAMDashboard();
  const airDashboard = useAIRDashboard();
  const flmsDashboard = useFLMSDashboard();
  const fmsDashboard = useFmsDashboard();
  const solarDashboard = useSolarDashboard();
  const bmsDashboard = useBmsDashboard();

  return {
    items: [emsDashboard],
    dg_items: [dgDashboard],
    bms_items: [bmsDashboard],
    wms_items: [wmsDashboard],
    temp_items: [tempDashboard],
    pump_items: [pumpDashboard],
    indoor_items: [indoorDashboard],
    outdoor_items: [outdoorDashboard],
    fms_items: [fmsDashboard],
    hvc_items: [hvcDashboard],
    boiler_items: [boilerDashboard],
    vib_items: [vibDashboard],
    // nbs_items: [nbs_dashboard],
    nbs_items: [nbsDashboard],
    trans_items: [transDashboard],
    agr_items: [agrDashboard],
    gas_items: [gasDashboard],
    steam_items: [steamDashboard],
    air_items: [airDashboard],
    flms_items: [flmsDashboard],
    solar_items: [solarDashboard],
    // superAdmin_items: [superAdmin_dashboard],
    superAdmin_items:[superDashboard],
    admin_items: [adminDashboard],
    support_items: [support_dashboard],
  };
};
